import { Http, EndPoints, getParams, TypeParams, TypeResource, CompanyID, parseParametersToSendBackend } from '../../core/utils';
import { DtcAck } from '../models/Reempujon';
import { TableFiltersParams } from '../models/panel';


export const ReempujonServices = {
    //items panel de gestion
    getManagementPanelItems: (cancelToken:any, params: TableFiltersParams): Promise<any> =>
        Http.get(`${EndPoints.ReempujonUrls.MANAGEMENT_PANEL_ITEMS}`, {
            cancelToken: cancelToken.token,
            params: params,
            paramsSerializer: params => {
                return parseParametersToSendBackend(params)
            }
        }).then(
            response => response.data
        ),

    getProperties: (): Promise<any> =>
        Http.get(`${EndPoints.ReempujonUrls.PROPERTIES}`, {}).then(
            response => response.data
        ),

    markDtcAck: (params: DtcAck): Promise<any> =>
        Http.post(`${EndPoints.ReempujonUrls.DTC_ACK}`, params).then(
            response => response.data
        ),
};

const joinParams = (ids: CompanyID[] | string[], separator: string) => ids.join(separator);
